import { defineRouting } from "next-intl/routing";

// Single source of truth for locales. Add a 3rd language here + one messages
// file, and middleware/switcher/SEO pick it up automatically.
export const routing = defineRouting({
  locales: ["en", "th"],
  defaultLocale: "en",
  // EN is served unprefixed (/about-us); other locales are prefixed (/th/about-us).
  localePrefix: "as-needed",
  // URLs select the language; browser preferences and a previous Thai visit
  // must not redirect the English homepage (or other unprefixed pages).
  localeDetection: false,
});
